import axios from "axios";
import { APIPath } from "baserURL";

const service = axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL,
  baseURL: APIPath
});

export default service;
